import GroupsFilters from "./groupsFilters";

export default class FeaturedMenuFilter {
    constructor(groupsFilters) {
        this.filterName = 'featuredmenu';
        this.groupsFilters = groupsFilters;
        this.eventDelegation();
    }

    eventDelegation() {
        window.addEventListener('load', () => {
            this.getOptionByUrlParams();
        });

        const featuredMenuOptions = document.querySelectorAll('[data-featured-menu]');
        featuredMenuOptions.forEach((featuredMenuOption) => {
            featuredMenuOption.addEventListener('click', (event) => {
                event.preventDefault();
                const currentTarget = event.currentTarget;
                featuredMenuOptions.forEach((option) => {
                    option.classList.remove('featured-menu-item-active');

                });
                featuredMenuOption.classList.add('featured-menu-item-active');
                this.groupsFilters._filterResultsModuleVisibility(false);

                let getParams = new URLSearchParams(window.location.search);
                Array.from(getParams.entries()).forEach((entry) => {
                    if (this.groupsFilters.filterAvailableOptions.includes(entry[0])) {
                        getParams.delete(entry[0]);
                    }
                });


                const featuredMenuName = currentTarget.getAttribute('data-featured-menu-name');

                this.groupsFilters.restoreFilterCheckboxes();
                this.groupsFilters.removeAllAppliedFilters();
                this.groupsFilters.restoreFilterParams();
                this._filter(currentTarget);

                if (featuredMenuName !== 'all') {
                    getParams.append(this.filterName, featuredMenuName);
                }

                if (getParams.size > 0) {
                    window.history.replaceState({}, '', '?' + getParams.toString());
                } else {
                    window.history.replaceState({}, '', window.location.pathname);
                }
            });
        });
    }

    getOptionByUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const option = urlParams.get(this.filterName);
        const optionContainer = document.querySelector('[data-featured-menu-name="' + option + '"][data-featured-menu]');

        if (!optionContainer && option) {
            const filterOverlay = $('#filter_overlay');

            if (filterOverlay.is(':visible')) {
                filterOverlay.fadeOut(1000);
            }
            return;
        }

        if (optionContainer) {
            this._filter(optionContainer);
        }
    }

    _filter(featuredMenuOption) {
        const featuredMenuName = featuredMenuOption.getAttribute('data-featured-menu-name');
        const sortLg = $('[data-name="sort-lg"]');

        this.groupsFilters.filtersApplied[this.filterName] = [];
        if (featuredMenuName === 'all') {
            this.groupsFilters.doFilter();
            sortLg.addClass('d-flex').removeClass('d-none');
            return;
        }

        let optionValue = featuredMenuOption.getAttribute('data-featured-menu');
        if (optionValue) {
            optionValue = parseInt(optionValue);
            this.groupsFilters.filtersApplied[this.filterName].push(optionValue);
        }

        this.groupsFilters.doFilter();

        if (optionValue) {
            const groups = document.querySelectorAll('[data-entity="group"]');
            const visibleGroups = Array.from(groups).filter((group) => {
                return group.style.display !== 'none';
            });


            if (optionValue === 4) {
                sortLg.addClass('d-none').removeClass('d-flex');
            } else {
                sortLg.addClass('d-flex').removeClass('d-none');
            }

            if (visibleGroups.length <= 0) {
                let getParams = new URLSearchParams(window.location.search);
                Array.from(getParams.entries()).forEach((entry) => {
                    if (entry[0] === this.filterName) {
                        getParams.delete(entry[0]);
                    }
                });

                if (getParams.size > 0) {
                    window.location.href = window.location.origin + window.location.pathname + '?' + getParams.toString();
                } else {
                    window.location.href = window.location.origin + window.location.pathname;
                }
            }
        }
    }
};
